module.exports = __webpack_public_path__ + "img/noti_manual.3d07f01f.jpg";